const COLOURS = [
  'Kathaakali',
  'Orange',
  'Silver',
  'Black',
  'Navy',
  'Red',
];

const selected = {
  colour: new Set(),
};

function cards() {
  return [...document.querySelectorAll('.product-grid__item[data-product-title]')];
}

function coloursFromTitle(title) {
  return COLOURS.filter((colour) => new RegExp(`\\b${colour}\\b`, 'i').test(title));
}

function unique(values) {
  return [...new Set(values)].sort((a, b) => a.localeCompare(b));
}

function renderOptions(key, values) {
  document.querySelectorAll(`[data-men-filter-options="${key}"]`).forEach((list) => {
    const suffix = list.getAttribute('data-men-filter-suffix') || 'desktop';
    list.innerHTML = values
      .map((value, index) => {
        const id = `men-filter-${key}-${suffix}-${index}`;
        return `
          <li class="facets__inputs-list-item">
            <input type="checkbox" id="${id}" value="${value}" data-men-filter-input="${key}">
            <label for="${id}">${value}</label>
          </li>
        `;
      })
      .join('');
  });
}

function syncInputs() {
  document.querySelectorAll('[data-men-filter-input]').forEach((input) => {
    const key = input.getAttribute('data-men-filter-input');
    if (!key) return;
    input.checked = selected[key].has(input.value);
  });
}

function applyFilters() {
  cards().forEach((card) => {
    const title = card.getAttribute('data-product-title') || '';
    const colours = coloursFromTitle(title);
    const colourOk =
      selected.colour.size === 0 || colours.some((colour) => selected.colour.has(colour));
    card.hidden = !colourOk;
  });

  document.querySelectorAll('[data-men-filter]').forEach((item) => {
    const key = item.getAttribute('data-men-filter');
    const status = item.querySelector('[data-men-filter-status]');
    if (!status || !key) return;
    const count = selected[key].size;
    status.textContent = count > 1 ? String(count) : count === 1 ? [...selected[key]][0] : '';
  });

  syncInputs();
}

function populate() {
  const titles = cards().map((card) => card.getAttribute('data-product-title') || '');
  if (!titles.length) return;
  renderOptions('colour', unique(titles.flatMap(coloursFromTitle)));
  applyFilters();
}

function init() {
  populate();

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-men-filter-input]');
    if (!input) return;
    const key = input.getAttribute('data-men-filter-input');
    if (!key) return;
    if (input.checked) selected[key].add(input.value);
    else selected[key].delete(input.value);
    applyFilters();
  });

  document.addEventListener('shopify:collection:update', (event) => {
    const promise = event.detail?.promise;
    if (promise && typeof promise.then === 'function') {
      promise.then(() => populate()).catch(() => populate());
      return;
    }
    populate();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
